
import { isBefore } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import Swal from 'sweetalert2';
import { UserTable, setFocus, GetDate, ReverseFormatDate, setTitle } from '../Common/Common';
import "react-datepicker/dist/react-datepicker.css";
import { post } from '../Common/service';
import { API_SERVER } from '../../EnvConfig/env_config';
import { useNavigate } from "react-router-dom";
import { AlertBox, AutoCompleteBox } from '../Common/Input';

const SAPAPIDATA = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const [MenuText, setMenuText] = useState("SWAP API DATA");
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [dateOfJoining, setDateOfJoining] = useState('');
    const [active, setActive] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        FromDate: GetDate(0),
        IsSwapData: true,
    });
    const filterFutureDates = (date) => {
        return isBefore(date, new Date());
    }
    const handleClear = () => {
        setFormData({
            FromDate: GetDate(0),
            IsSwapData: true,
        });
        setDateOfJoining(GetDate(0))
    }
    
    const handleSubmit = async () => {
        Swal.fire({
            title: 'Do you want to swap the data?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                const loginCodeString = String(LoginUserCode);
                let data = {
                    ...formData, Token, LoginUserCode: loginCodeString
                };
                post(`${API_SERVER}/api/Dashboard/SwapData`, { ...data }, (res) => {
                    if (res.status === 'SUCCESS') {
                        setIsLoading(false);
                        AlertBox(res.status, res.message, "");
                        handleClear();
                    }
                    else if (res.message === "EXPIRED") {
                        navigate('/Login');
                    }
                    else if (res.message !== "") {
                        AlertBox(res.status, res.message, res.focus);
                    }
                    setIsLoading(false);
                });
            }
        });
    };


    useEffect(() => {
        setTitle('SWAP API Data', setOpen);
     
    }, )
    return (
        <>
            <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
                <section className="section dashboard">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="content-box">
                                <div className="heading-box">
                                    <div className="heading">
                                        <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                    </div>
                                </div>
                                <div className="form-box service-content-area">
                                    <div className="row align-items-end">
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Date</label>
                                                <DatePicker
                                                    selected={ReverseFormatDate(formData.FromDate)}
                                                    id="txtDOJ"
                                                    disabled={true }
                                                    className="form-control"
                                                    placeholderText="Date"
                                                    dateFormat="dd-MMM-yyyy"
                                                    autoComplete="off"
                                                    onChange={(date) => {
                                                        setDateOfJoining({ ...formData, FromDate: setDateOfJoining(date) })
                                                    }}
                                                    maxDate={new Date()}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            setFocus("activeCheckbox");
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="form-check form-switch">
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="activeCheckbox"
                                                >
                                                    SWAP Data
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="activeCheckbox"
                                                    name='Active'
                                                    checked={formData.IsSwapData}
                                                    onChange={(e) => {
                                                        setActive({
                                                            ...formData, IsSwapData: e.target.checked
                                                        })
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            handleSubmit();
                                                        };
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12 mt-4">
                                            <div className="lms-new-button text-center">
                                               <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Swap Data
                                                </button>
                                                <button className="button reset-btn" onClick={handleClear}>
                                                    <i className="bi bi-arrow-clockwise" /> Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}
export default SAPAPIDATA

